import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { CheckBG } from "../../../../core/icons/CheckBG";

export const List = ({ text, subtext }: { text: string; subtext?: string }) => {
	return (
		<Row className="gap-2">
			<CheckBG className="md:mt-0.5 min-w-4 min-h-4 max-w-4 max-h-4" />
			<Column className="gap-0.5">
				<TextComponent
					variant="h6"
					className="font-semibold"
				>
					{text}
				</TextComponent>
				<TextComponent
					variant="h6"
					className="text-graySecondary"
				>
					{subtext}
				</TextComponent>
			</Column>
		</Row>
	);
};
